import type { ChatMessage } from "@loot-os/api-contract";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@loot-os/ui/components/dropdown-menu";
import { Copy, Ellipsis, Eye, EyeOff, Flag, Trash2 } from "lucide-react";

/**
 * A message's "…" menu in its actions pill (boxed's ChatActions, without the moderator items:
 * staff moderate from the dashboard; Reply sits beside it in the pill). Copy for everyone; Delete
 * on your own; Report and Ignore on others'.
 */
export function ChatActionsMenu({
  message,
  own,
  signedIn,
  ignored,
  onReport,
  onDelete,
  onToggleIgnore,
}: {
  message: ChatMessage;
  own: boolean;
  signedIn: boolean;
  ignored: boolean;
  onReport: () => void;
  onDelete: () => void;
  onToggleIgnore: () => void;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="flex size-4 items-center justify-center hover:text-foreground data-[popup-open]:text-foreground"
        aria-label={`Actions for ${message.displayName}'s message`}
      >
        <Ellipsis className="size-4" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-40">
        {message.text && (
          <DropdownMenuItem
            onClick={() => {
              void navigator.clipboard?.writeText(message.text ?? "").catch(() => undefined);
            }}
          >
            <Copy /> Copy text
          </DropdownMenuItem>
        )}
        {own ? (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem variant="destructive" onClick={onDelete}>
              <Trash2 /> Delete
            </DropdownMenuItem>
          </>
        ) : (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={onToggleIgnore}>
              {ignored ? <Eye /> : <EyeOff />} {ignored ? "Unignore player" : "Ignore player"}
            </DropdownMenuItem>
            {signedIn && (
              <DropdownMenuItem variant="destructive" onClick={onReport}>
                <Flag /> Report
              </DropdownMenuItem>
            )}
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
